import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ArrowUp = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.63313 7.01733C3.45562 6.84996 3.45562 6.57861 3.63313 6.41124L8.17859 2.12553C8.3561 1.95816 8.6439 1.95816 8.82141 2.12553L13.3669 6.41124C13.5444 6.57861 13.5444 6.84996 13.3669 7.01733C13.1894 7.1847 12.9016 7.1847 12.724 7.01733L8.95455 3.46323L8.95455 13.5714C8.95455 13.8081 8.75104 14 8.5 14C8.24896 14 8.04545 13.8081 8.04545 13.5714L8.04545 3.46323L4.27596 7.01733C4.09845 7.1847 3.81064 7.1847 3.63313 7.01733Z"
        fill={color}
      />
    </svg>
  )
})

export default ArrowUp
